var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Breadcrumb',{attrs:{"options":_vm.breadcrumb}}),_c('Wxts',{attrs:{"wxtsList":_vm.wxtsList}}),_c('TabMenu',{attrs:{"menuIndex":_vm.menuIndex,"menu":_vm.menu}}),_c('div',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }